/**
 * Validates encrypted ID string (used for cases, investigations, etc.)
 * Throws error if ID is invalid - use in repositories/APIs for defensive validation.
 *
 * @param id - ID to validate
 * @param entityName - Name of entity for error message (e.g., 'case', 'investigation')
 * @throws Error if ID is invalid
 *
 * @example
 * validateEncryptedId('abc123', 'case'); // OK
 * validateEncryptedId('', 'investigation'); // throws Error
 * validateEncryptedId(null, 'case'); // throws Error
 */
export function validateEncryptedId(id: string, entityName = 'ID'): void {
  if (!id || typeof id !== 'string' || id.trim().length === 0) {
    throw new Error(`Invalid ${entityName}: ${id}`);
  }
}
